<app-brand-select></app-brand-select>
<app-newsletter-form class="modal-open"></app-newsletter-form>
<app-empty-modal></app-empty-modal>
<app-share></app-share>
<app-compare-modal></app-compare-modal>
